import { FunctionComponent } from 'react';
import { IconButtonProps } from '@mui/material/IconButton';
import { Classnames } from '@cbridge-utils/mui-theme';
import { PrimaryIconButton } from '../PrimaryIconButton/PrimaryIconButton';

export const HoverActionButton: FunctionComponent<IconButtonProps> = (props) => {
  return (
    <PrimaryIconButton
      className={Classnames.VISIBLE_ON_HOVER}
      size={'small'}
      sx={{
        padding: 0,
      }}
      {...props}
    />
  );
};
